import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { DocumentNodeSelectorInputModule } from '@portal-core/project-files/components/document-node-selector-input/document-node-selector-input.module';
import { ProjectFilePickerInputModule } from '@portal-core/project-files/components/project-file-picker-input/project-file-picker-input.module';
import { DividerModule } from '@portal-core/ui/divider/components/divider/divider.module';
import { DropdownArrowModule } from '@portal-core/ui/forms/components/dropdown-arrow/dropdown-arrow.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { LinkPropertiesDialogComponent } from './link-properties-dialog.component';

@NgModule({
  declarations: [
    LinkPropertiesDialogComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    ReactiveFormsModule,
    ErrorsExpansionPanelModule,
    LoaderModule,
    DropdownArrowModule,
    MatFormFieldModule,
    MatTreeModule,
    MatToolbarModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    ProjectFilePickerInputModule,
    DividerModule,
    MatRippleModule,
    MatExpansionModule,
    DocumentNodeSelectorInputModule
  ],
  exports: [
    LinkPropertiesDialogComponent
  ]
})
export class LinkPropertiesDialogModule { }
